import { useEffect, useState, useRef } from "react";
import { Edit, Trash2, Search, Eye, Filter, List } from "lucide-react";
import Video from "./VideoModal.js";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import API_BASE_URL from "./Config.js";
import { set } from "date-fns";

export default function VideoList() {
  const [searchTerm, setSearchTerm] = useState("");
  const [thumbnailPreview, setThumbnailPreview] = useState("");
  const [filterProductId, setFilterProductId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [videoToEdit, setVideoToEdit] = useState(null);
  const [videoToDelete, setVideoToDelete] = useState(null);
  const [videos, setVideos] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [videoView, setVideoView] = useState(null);
  const [videoPreview, setVideoPreview] = useState(null);
  const [products, setProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState("");
  const [loading,setLoading] = useState(false);

  const navigate = useNavigate();
  useEffect(() => {
    const token = Cookies.get("token");
    if (!token) {
      toast.error("You need to log in first.");
      navigate("/");
    }
    fetch(`${API_BASE_URL}products`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.products) {
          setProducts(data.products);
        } else {
          toast.error("Some Error Occured");
        }
      })
      .catch((error) => console.error("Server Error:", error));
  }, []);

  const [formEditData, setFormData] = useState({
    videoId: "",
    productId: "",
    fileName: "",
    title: "",
    description: "",
    eventKeywords: "",
    file: null,
    thumbnail: null,
  });
  const thumbnailInputRef = useRef(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    const matchedProduct = products.find(
      (product) => product.productName === formEditData.productId
    );
    if (matchedProduct) {
      setSelectedProduct(matchedProduct.productId);
    }
  }, [formEditData.productId, products]);

  useEffect(() => {
    if (videoToEdit) {
      setFormData({
        videoId: videoToEdit.videoId || "",
        productId: videoToEdit.productName || "",
        fileName: videoToEdit.fileName || "",
        title: videoToEdit.title || "",
        description: videoToEdit.description || "",
        eventKeywords: videoToEdit.eventKeywords || "",
        file: videoToEdit.file ? videoToEdit.file : "",
        thumbnail: videoToEdit.thumbnail ? videoToEdit.thumbnail : "",
      });
      if (videoToEdit.thumbnail) {
        setThumbnailPreview(`data:image/png;base64,${videoToEdit.thumbnail}`);
      }
      if (videoToEdit.videoUrlFinal) {
        setVideoPreview(videoToEdit.videoUrlFinal);
      }
    }
  }, [videoToEdit]);

  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prev) => ({ ...prev, thumbnail: file }));
      setThumbnailPreview(URL.createObjectURL(file));
      if (thumbnailInputRef.current) {
        thumbnailInputRef.current.value = "";
      }
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formEditData, file: file, fileName: file.name });
      setVideoPreview(URL.createObjectURL(file));
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formEditData, [name]: value });
  };

  const handleDeleteSubmit = async (e) => {
    e.preventDefault();
    const token = Cookies.get("token");
    if (!token) {
      toast.error("You need to log in first.");
      navigate("/");
    }

    try {
      const response = await fetch(`${API_BASE_URL}delete/${videoToDelete.videoId}`, {
        method: "PUT",
      });
      if (response.ok) {
        toast.success("Video Delete successfully");
        closeModal();
        fetchVideos();
        setShowDeleteModal(false);
        setVideoToDelete(null);
      }
      if (!response.ok) {
        toast.error("Video Deletion failed");
        throw new Error(`Deletion failed`);
      }
    } catch (error) {
      toast.error("Video Deletion failed");
    }
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    const token = Cookies.get("token");
    if (!token) {
      toast.error("You need to log in first.");
      navigate("/");
    }

    const formEditDataToSend = new FormData();
    const userId = Cookies.get("userId");
    formEditDataToSend.append("VideoId", formEditData.videoId);
    formEditDataToSend.append("ProductId", selectedProduct);
    formEditDataToSend.append("FileName", formEditData.fileName);
    formEditDataToSend.append("Title", formEditData.title);
    formEditDataToSend.append("Description", formEditData.description);
    formEditDataToSend.append("Keywords", formEditData.eventKeywords);
    formEditDataToSend.append("VideoUrl", "./test");
    formEditDataToSend.append("ThumbnailUrl", "./test");
    formEditDataToSend.append("UploadedBy", userId);

    if (formEditData.file) { 
      formEditDataToSend.append("VideoFile", formEditData.file);
    }
    

    if (formEditData.thumbnail instanceof File) {
      formEditDataToSend.append("Thumbnail", formEditData.thumbnail);
    } else if (typeof formEditData.thumbnail === "string") {
      const convertedFile = base64ToFile(
        formEditData.thumbnail,
        "thumbnail.png"
      );
      formEditDataToSend.append("Thumbnail", convertedFile);
    } else {
      console.warn("⚠️ No valid thumbnail found, skipping thumbnail upload.");
    }

    formEditDataToSend.append("Status", "Active");

    try {
      const response = await fetch(`${API_BASE_URL}update`, {
        method: "PUT",
        body: formEditDataToSend,
      });
      if (response.ok) {
        toast.success("Video Edited successfully");
        closeModal();
        fetchVideos();
        setShowEditModal(false);
      }
      if (!response.ok) {
        toast.error("Video Update failed");
        throw new Error(`Update failed`);
      }
    } catch (error) {
      toast.error("Video Update failed");
    }
  };

  const openModal = () => {
    setIsModalOpen(true);
  };
  const handleViewClick = (video) => {
    setVideoView(video);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const base64ToFile = (base64String, fileName, mimeType) => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new File([byteArray], fileName, { type: mimeType });
  };

  const fetchVideos = () => {
    setLoading(true);
    fetch(`${API_BASE_URL}videos`, {
      headers: {
        "Authorization": `Bearer ${Cookies.get("token")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.videos) {
          setVideos(data.videos);
          console.log(data.videos);
        }
      })
      .catch((error) => console.error("Server Error:", error))
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchVideos();
  }, []);

  const uniqueProductIds = [
    ...new Set(videos.map((video) => video.productName)),
  ];

  const filteredVideos = videos
    .filter((video) => {
      const matchesSearch =
        searchTerm === "" ||
        video.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
        video.description.toLowerCase().includes(searchTerm.toLowerCase()) ||
        video.eventKeywords
          .split(",")
          .map((k) => k.trim().toLowerCase())
          .some((k) => k.includes(searchTerm.toLowerCase()));

      const matchesProductId =
        filterProductId === "" || video.productName === filterProductId;

      return matchesSearch && matchesProductId;
    })
    .sort((a, b) => new Date(b.uploadedAt) - new Date(a.uploadedAt));

  const handleDeleteClick = (video) => {
    setVideoToDelete(video);
    setShowDeleteModal(true);
  };

  const handleEditClick = (video) => {
    setVideoToEdit(video);
    setShowEditModal(true);
  };

   return (
    <div className="container-fluid p-0">
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-0 shadow-sm">
            <div className="card-header bg-white py-3">
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <h4 className="card-title mb-0">Video Library</h4>
                <div className="d-flex gap-2 mt-2 mt-md-0">
                  <div className="input-group">
                    <span className="input-group-text bg-light">
                      <Search size={18} />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search videos..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                    />
                  </div>

                  <div className="input-group">
                    <span className="input-group-text bg-light">
                      <Filter size={18} />
                    </span>
                    <select
                      className="form-select"
                      value={filterProductId}
                      onChange={(e) => setFilterProductId(e.target.value)}
                    >
                      <option value="">All Products</option>
                      {uniqueProductIds.map((id) => (
                        <option key={id} value={id}>
                          {id}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="card-body p-0">
              {filteredVideos.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-hover align-middle mb-0">
                    <thead className="table-light">
                      <tr>
                        <th className="ps-4">Video</th>
                        <th>Product Name</th>
                        <th>Title</th>
                        <th>Upload Date</th>
                        <th>Status</th>
                        <th className="text-end pe-4">Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredVideos.map((video) => (
                        <tr key={video.videoId}>
                          <td className="ps-4">
                            <div className="d-flex align-items-center">
                              <div
                                className="position-relative"
                                style={{ width: "120px", height: "68px" }}
                              >
                                <img
                                  src={`data:image/jpeg;base64,${video.thumbnail}`}
                                  alt={video.title}
                                  className="img-fluid rounded"
                                  style={{
                                    width: "120px",
                                    height: "68px",
                                    objectFit: "cover",
                                  }}
                                />
                              </div>
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-light text-dark">
                              {video.productName}
                            </span>
                          </td>
                          <td>
                            <div
                              className="fw-semibold text-truncate"
                             
                            >
                              {video.title}
                            </div>
                          </td>
                          <td>
                            {new Date(video.uploadedAt).toLocaleDateString(
                              "en-GB",
                              {
                                day: "2-digit",
                                month: "2-digit",
                                year: "numeric",
                              }
                            )}
                          </td>
                          <td>
                            <span
                              className={`badge ${
                                video.status === "Active"
                                  ? "bg-success"
                                  : "bg-danger"
                              }`}
                            >
                              {video.status}
                            </span>
                          </td>
                          <td className="text-end pe-4">
                            <div className="btn-group">
                              <button
                                className="btn btn-sm btn-outline-primary"
                                onClick={() => handleViewClick(video)}
                                title="View Details"
                              >
                                <Eye size={16} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => handleEditClick(video)}
                                title="Edit"
                              >
                                <Edit size={16} />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={() => handleDeleteClick(video)}
                                title="Delete"
                              >
                                <Trash2 size={16} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (

                
                  loading ? (
                    <>
                   <div className="text-center py-5">
  <h5 className="text-muted mb-3 animate__animated animate__fadeInDown">Loading videos...</h5>
  <div className="d-flex justify-content-center gap-3">
    <div className="spinner-grow text-primary" role="status" style={{ width: "2rem", height: "2rem" }}></div>
    <div className="spinner-grow text-success" role="status" style={{ width: "2rem", height: "2rem" }}></div>
    <div className="spinner-grow text-danger" role="status" style={{ width: "2rem", height: "2rem" }}></div>
  </div>
</div>


                    </>
                  ) : (
                    <>
                    <div className="text-center py-5">
                  <div>
                    <img src="./not-found.png" alt="Video Not Found" height={300}/>
                  </div>
                  <h5 className="text-muted">No videos found</h5>
                  {searchTerm && (
                    <p className="text-muted">
                      No videos match your search for "{searchTerm}"
                    </p>
                  )}
                  {filterProductId && (
                    <p className="text-muted">
                      No videos found for Product ID "{filterProductId}"
                    </p>
                  )}
                </div>
                  </>
                  )
                

                  
                )
                }
                
              
            </div>
          </div>
        </div>
      </div>

      {showDeleteModal && (
        <div
          className="modal fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Confirm Delete</h5>
                <button
                  className="btn-close"
                  onClick={() => setShowDeleteModal(false)}
                ></button>
              </div>
              <div className="modal-body">
               
                  <div
                    className="col-12"
                    style={{ width: "100%",height:'60vh'}}
                  >
                    <img
                      src={`data:image/jpeg;base64,${videoToDelete?.thumbnail}`}
                      alt={videoToDelete.title}
                      className="img-fluid rounded"
                      style={{
                        width: "100%",
                        height:'90%',
                        objectFit: "contain",
                      }}
                    />
                      Are you sure you want to delete <b>{videoToDelete?.title}</b>?
                  </div>
              </div>
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setShowDeleteModal(false)}
                >
                  Cancel
                </button>
                <button className="btn btn-danger" onClick={handleDeleteSubmit}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEditModal && (
        <div
          className="modal modal-xl fade show d-block"
          tabIndex="-1"
          style={{ background: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h3 className="modal-title">Edit Video</h3>
                <button
                  className="btn-close"
                  onClick={() => setShowEditModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="card-body p-3">
                  <form onSubmit={handleEditSubmit}>
                    <div className="row">
                      <div className="col-lg-8">
                        <div className="row">
                          <div className="col-lg-6 mb-3">
                            <div className="mb-3">
                              <label
                                htmlFor="productSelect"
                                className="form-label fw-semibold"
                              >
                                Select a Product
                              </label>
                              <select
                                id="productSelect"
                                className="form-select"
                                value={formEditData.productId}
                                onChange={(e) =>
                                  setFormData({
                                    ...formEditData,
                                    productId: e.target.value,
                                  })
                                }
                                required
                              >
                                <option value="" disabled>
                                  Select a Product
                                </option>
                                {products.map((product) => (
                                  <option
                                    key={product.productId}
                                    value={product.productName}
                                  >
                                    {product.productName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="col-lg-6 mb-3">
                            <div className="mb-3">
                              <label
                                className="form-label fw-semibold"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "start",
                                }}
                              >
                                Video Title
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                name="title"
                                value={formEditData.title}
                                onChange={handleInputChange}
                                required
                                placeholder="Enter video title"
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            Description
                          </label>
                          <textarea
                            type="text"
                            className="form-control"
                            name="description"
                            rows={4}
                            value={formEditData.description}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter video Description"
                          />
                        </div>

                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            Keywords
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="eventKeywords"
                            value={formEditData.eventKeywords}
                            onChange={handleInputChange}
                            placeholder="Enter keywords separated by commas"
                          />
                        </div>
                        <div className="row">
                          <div className="col-lg-6 mb-3">
                            <div className="mb-3">
                              <label
                                className="form-label fw-semibold"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "start",
                                }}
                              >
                                Change Video File
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                accept="video/*"
                                onChange={handleFileChange}
                                ref={fileInputRef}
                              />
                            </div>
                          </div>
                          <div className="col-lg-6 mb-3">
                            <div className="mb-3">
                              <label
                                className="form-label fw-semibold"
                                style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  alignItems: "start",
                                }}
                              >
                                Change Thumbnail Image
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                accept="image/*"
                                onChange={handleThumbnailChange}
                                ref={thumbnailInputRef}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="mb-3">
                          <label
                            className="form-label fw-semibold"
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "start",
                            }}
                          >
                            File Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            name="fileName"
                            value={formEditData.fileName}
                            onChange={handleInputChange}
                            required
                            placeholder="Enter File Name"
                          />
                        </div>
                      </div>

                      <div className="col-lg-4 bg-light p-4 rounded border">
                        <div
                          className="card-header bg-light mb-4"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "start",
                          }}
                        >
                          <h5 className="mb-0">
                            <i className="bi bi-eye"></i> &nbsp;Preview
                          </h5>
                        </div>
                        <h6>Selected Video</h6>
                        {videoPreview ? (
                          <div className="mb-3">
                            <div className="ratio ratio-16x9 mb-3 bg-dark rounded">
                              <video
                                src={videoPreview}
                                controls
                                className="rounded"
                              ></video>
                            </div>
                          </div>
                        ) : (
                          <div className="mb-3 text-center py-4 bg-dark bg-opacity-10 rounded">
                            <div className="py-4">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="48"
                                height="48"
                                fill="currentColor"
                                className="bi bi-file-earmark-play text-muted mb-2"
                                viewBox="0 0 16 16"
                              >
                                <path d="M6 6.883v4.234a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L6.757 6.454a.5.5 0 0 0-.757.43z" />
                                <path d="M14 14V4.5L9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2zM9.5 3A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5.5v2z" />
                              </svg>
                              <p className="text-muted">
                                Video preview will appear here
                              </p>
                            </div>
                          </div>
                        )}

                        <h6>Selected Thumbnail</h6>
                        {thumbnailPreview ? (
                          <div>
                            <div className="mb-3 bg-dark rounded">
                              <img
                                src={thumbnailPreview || "/placeholder.svg"}
                                alt={formEditData.title}
                                className="img-fluid rounded w-100"
                                style={{
                                  maxHeight: "150px",
                                  objectFit: "cover",
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="text-center py-3 bg-dark bg-opacity-10 rounded">
                            <div className="py-3">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="48"
                                height="48"
                                fill="currentColor"
                                className="bi bi-image text-muted mb-2"
                                viewBox="0 0 16 16"
                              >
                                <path d="M6.002 5.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                                <path d="M2.002 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2h-12zm12 1a1 1 0 0 1 1 1v6.5l-3.777-1.947a.5.5 0 0 0-.577.093l-3.71 3.71-2.66-1.772a.5.5 0 0 0-.63.062L1.002 12V3a1 1 0 0 1 1-1h12z" />
                              </svg>
                              <p className="text-muted small">
                                Thumbnail preview will appear here
                              </p>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="d-flex justify-content-end gap-2 mt-4 modal-footer">
                      <button
                        type="button"
                        className="btn btn-danger btn px-4"
                        onClick={() => setShowEditModal(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary btn px-4"
                      >
                        Edit Video
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <Video isOpen={isModalOpen} onClose={closeModal} videoData={videoView} />
    </div>
  );
}
